module.exports = __webpack_public_path__ + "static/media/stackedLogo.0180aba4.png";